import {connect} from 'react-redux';
import {SolutionContents as Component} from './SolutionContents';

import {
  setSolutionControlVisibility,
  setHeldObject,
  setSolutionHeld,
  setShowSolutionContents
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    type: ownProps.type,
    connect: ownProps.connect,
    id: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.connect-1].id,
    display: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.connect-1].showSolutionContents,
    solutions: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.connect-1].solutions,
    volume: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.connect-1].volume,
    solutionAlias: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.connect - 1].solutionAlias,
    renamable: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.connect - 1].renamable,
    fullName: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.connect - 1].fullName,
    labelReactionTubes: state.notebook.protocolSection.scene.labelReactionTubes,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setSolutionControlVisibility: (data) => {
      dispatch(setSolutionControlVisibility(data))
    },
    setHeldObject: (data) => {
      dispatch(setHeldObject(data))
    },
    setSolutionHeld: (data) => {
      dispatch(setSolutionHeld(data))
    },
    setShowSolutionContents: (data) => {
      dispatch(setShowSolutionContents(data))
    }
  };
}

export const SolutionContents = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
